import { Fragment, FunctionalComponent, h } from '@stencil/core';
import { DsMobileNavigationLink } from './ds-mobile-navigation-link';

export type MobileMenuItem = {
  title: string;
  url?: string;
  externalLink?: boolean;
  items?: Array<MobileMenuItem>;
};
interface DsMobileNavigationMenuProps {
  items: Array<MobileMenuItem>;
  onItemClick: (item: MobileMenuItem, event?: MouseEvent, index?: number) => void;
}

export const DsMobileNavigationSubmenuList: FunctionalComponent<DsMobileNavigationMenuProps> = ({
  items,
  onItemClick
}) => (
  <Fragment>
    {items.map((item, index) => (
      <li key={item.title} role='none'>
        {item.items?.length ? (
          <ds-navigation-button
            class='link-item'
            color='transparent'
            accessibilityAttributes={{ hasPopup: true }}
            onClick={(event) => onItemClick(item, event, index)}
            elementRole='menuitem'
          >
            <div class='button-content-wrapper'>
              <span>{item.title}</span>
              <ds-icon aria-hidden='true' name='NavigationArrowRight' class='link-item__icon' />
            </div>
          </ds-navigation-button>
        ) : (
          <DsMobileNavigationLink
            {...item}
            externalLink={!!item.externalLink}
            onClick={(event) => onItemClick(item, event)}
          />
        )}
      </li>
    ))}
  </Fragment>
);
